/**
 * `GET /me/calendar-feed` as `queryOptions` — ONE cache entry for `/konto`'s „Dodaj do Kalendarza
 * Apple" block and `/rezerwacje`'s one-time calendar card. Outside both screens' prefixes, so
 * neither's writes re-read it by accident. Asked only on an Apple device (`enabled`).
 */

import { queryOptions } from '@tanstack/react-query';

import { getMeCalendarFeed } from '~/shared/api/generated/endpoints/my-calendar-feed/my-calendar-feed';

export const calendarFeedQueryKey = ['calendar-feed'] as const;

export function calendarFeedQueryOptions(enabled: boolean) {
  return queryOptions({
    queryKey: calendarFeedQueryKey,
    queryFn: ({ signal }) => getMeCalendarFeed(undefined, signal),
    enabled,
  });
}
